import type { FC } from 'react';
import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { atoms, DropdownMenu, Primitive, VStack } from '@rtkwlf/fenrir-react';
import { faCaretDown } from '@rtkwlf/pro-solid-svg-icons/faCaretDown';
import { NavLink, useMatch } from 'react-router-dom';

import { NavigationHeader } from '../navigation-header/navigation-header';

interface NavigationTriggerProps {
  to: string;
  name: string;
  isDropdownTrigger?: boolean;
}

export const NavigationTrigger: FC<NavigationTriggerProps> = ({
  to,
  name,
  isDropdownTrigger,
}) => {
  const isActive = useMatch({ end: to === '/', path: to })?.pathname === to;

  const title = (
    <Primitive.span fontWeight={isActive ? 'bold' : 'normal'}>
      {name}
    </Primitive.span>
  );

  return (
    <VStack gap="small" paddingTop="small">
      {isDropdownTrigger ? (
        <DropdownMenu.Trigger
          backgroundColor="transparent"
          cursor="pointer"
          borderRadius="default"
          borderWidth="zero"
          padding="zero"
          focusOutline={{ focusVisible: 'default' }}
        >
          <NavigationHeader>
            {title} <FontAwesomeIcon icon={faCaretDown} />
          </NavigationHeader>
        </DropdownMenu.Trigger>
      ) : (
        <NavLink
          to={to}
          className={atoms({
            borderRadius: 'default',
            display: 'flex',
            focusOutline: { focusVisible: 'default' },
            textDecoration: 'none',
          })}
        >
          <NavigationHeader>{title}</NavigationHeader>
        </NavLink>
      )}

      <Primitive.div
        backgroundColor={isActive ? 'accentOrangeDefault' : 'transparent'}
        height="0.25rem"
        width="full"
        data-testid={isActive ? `highlighting--${to}` : undefined}
      />
    </VStack>
  );
};
